/**
 * Registro de la actividad del comprador para el panel (ADM-07, WSP-03).
 *
 * Va por `avisar` y no por `pedir`: al comprador no le importa el resultado y
 * un fallo aca no puede estorbar lo que estaba haciendo. Que no se anote un
 * clic es peor para el panel, no para la venta.
 *
 * Se registra que se abrio la conversacion, no que hubo venta: el sitio no
 * puede saber lo segundo y como confirmarlo sigue siendo una pregunta abierta.
 */
import type { RegistrarClicWhatsappDto } from '@bandu/compartido';

import { avisar } from './cliente-api';

export function registrarClicWhatsapp(datos: RegistrarClicWhatsappDto): void {
  avisar('/metricas/whatsapp', datos);
}
